import axios from 'axios';
import { config } from '../../config';
import { adminAuthHeaders } from './authHeaders';

export async function getAdminTeachers(params = {}) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/teachers`, {
        params,
        headers,
    });
    return data;
}

export async function getAdminTeacher(uid) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.get(`${host}/teachers/${uid}`, {
        headers,
    });
    return data;
}

// Milestone 2: profile edit (coordinator+ only server-side; this call will
// simply fail with a 403 for a viewer-role admin).
export async function updateAdminTeacher(uid, fields) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.put(`${host}/teachers/${uid}`, fields, {
        headers,
    });
    return data;
}

// Milestone 2: activate/deactivate. `status` is the numeric USER_STATUS code.
export async function updateAdminTeacherStatus(uid, status) {
    const host = `${config.service.host}/api/admin`;
    const headers = await adminAuthHeaders();
    const { data } = await axios.patch(`${host}/teachers/${uid}/status`, { status }, {
        headers,
    });
    return data;
}
